module.exports = __webpack_public_path__ + "img/corner_ic_original.d7f473ee.png";